import { render, staticRenderFns } from "./CreateAppVersionUpdates.vue?vue&type=template&id=2bb3c0e2&scoped=true"
import script from "./CreateAppVersionUpdates.vue?vue&type=script&lang=ts"
export * from "./CreateAppVersionUpdates.vue?vue&type=script&lang=ts"
import style0 from "./CreateAppVersionUpdates.vue?vue&type=style&index=0&id=2bb3c0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3c0e2",
  null
  
)

export default component.exports